import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Checkbox, { SR_CHECKBOX_THEME_INLINE, SR_CHECKBOX_LIST_THEME_ICON_BOX } from './Checkbox';

export const SR_CHECKBOX_LIST_LAYOUT_NO_WRAP = 'noGridWrap';
export const SR_CHECKBOX_LIST_THEME_BULLET_GRID = 'bulletGrid';

class SrCheckboxList extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    optionList: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
      PropTypes.bool,
    ]),
    multipleSelection: PropTypes.bool,
    useArrayValues: PropTypes.bool,
    allowEmptyArray: PropTypes.bool,
    toggleSingleSelection: PropTypes.bool,
    uncheckedValue: PropTypes.bool,
    fieldType: PropTypes.string,
    autoFitWidth: PropTypes.string,
    checkboxIconType: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    checkboxClassName: PropTypes.string,
  }

  static defaultProps = {
    value: [],
    multipleSelection: true,
    useArrayValues: false,
    allowEmptyArray: true,
    fieldType: SR_CHECKBOX_THEME_INLINE,
  }

  _onChangeCheckbox = (formValue) => {
    const {
      onChange,
      value,
      multipleSelection,
      useArrayValues,
      allowEmptyArray,
      toggleSingleSelection,
      uncheckedValue = false,
    } = this.props;

    if (!multipleSelection && !useArrayValues) {
      onChange(value === formValue && toggleSingleSelection
        ? uncheckedValue
        : formValue);
      return;
    }
    if (!multipleSelection && useArrayValues) {
      const newValue = value.includes(formValue) ? [] : [formValue];
      if (!allowEmptyArray && !newValue.length) {
        return;
      }
      onChange(newValue.sort());
      return;
    }

    const newValue = value.includes(formValue)
      ? value.filter((val) => val !== formValue)
      : [...value, formValue];

    if (!allowEmptyArray && !newValue.length) {
      return;
    }

    onChange(newValue.sort());
  }

  render() {
    const {
      optionList,
      value,
      multipleSelection,
      useArrayValues,
      disabled,
      fieldType,
      autoFitWidth,
      checkboxIconType,
      className,
      checkboxClassName,
    } = this.props;

    return (
      <div
        className={classnames(
          className,
          (fieldType === SR_CHECKBOX_LIST_THEME_ICON_BOX && optionList.length <= 2) ?
            SR_CHECKBOX_LIST_LAYOUT_NO_WRAP : SR_CHECKBOX_LIST_THEME_BULLET_GRID,
        )}
        style={{
          gridTemplateColumns: autoFitWidth ?
            `repeat(auto-fit, minmax(${autoFitWidth}, ${autoFitWidth}))` : null,
        }}
      >
        {optionList.map((option) => (
          <Checkbox
            key={option.value}
            isActive={value && (multipleSelection || useArrayValues)
              ? value.includes(option.value)
              : value === option.value
            }
            disabled={disabled || option.disabled}
            onClick={() => {
              this._onChangeCheckbox(option.value);
            }}
            icons={fieldType === SR_CHECKBOX_LIST_THEME_ICON_BOX ? {
              active: option.activeIconUrl,
              inactive: option.iconUrl,
            } : null}
            type={fieldType}
            checkboxIconType={checkboxIconType}
            noBackgroundImage={option.noBackgroundImage}
            className={checkboxClassName}
          >
            <span>
              {option.label}
            </span>
            {option.sublabel && (
              <span className='sublabel'>{option.sublabel}</span>
            )}
          </Checkbox>
        ))}
      </div>
    );
  }
}

SrCheckboxList.displayName = 'SrCheckboxList';

export default SrCheckboxList;
